import './index.scss';

import { Component } from 'react';

import { BraxThemeVariant } from '../../types';

import icon from '../../assets/images/mpv-icon.svg';
import logotype from '../../assets/images/mpv-logotype.svg';
import logomarkHorizontal from '../../assets/images/mpv-logomark-horizontal.svg';
import logomarkVertical from '../../assets/images/mpv-logomark-vertical.svg';

const logos = {
    'icon': icon,
    'logotype': logotype,
    'logomark-horizontal': logomarkHorizontal,
    'logomark-vertical': logomarkVertical
};

export type BraxLogoProps = {
    type: keyof typeof logos,
    variant: Extract<BraxThemeVariant, 'primary' | 'white' | 'black'>
};

export class BraxLogo extends Component<BraxLogoProps> {

    render() {
        const Logo = logos[this.props.type];

        return (
            <span className={`brax-logo ${this.props.variant}`}>
                <Logo width="100%" height="100%" />
            </span>
        );
    }

}
